import { findMany, on, fire } from '../Libraries/helpers';
import { getOffset } from '../Libraries/ScrollTo/offset';
import debounce from 'lodash/debounce';

const init = () => {
    let offset = getOffset() - 16

    on('sticky-sidebars::change', debounce(event => {
        offset = event.detail.offset
        fire('offset::change');
    }, 100));

    findMany('[data-sticky-sidebar]').forEach(sidebar => {
        const update = () => {
            // we subtract 40 because this is added on by default and we don't need it for this but then add some padding top of 24 so leaves us to minus 16
            const sidebarIsTallerThanScreen = (sidebar.clientHeight + offset) > window.innerHeight

            if (sidebarIsTallerThanScreen) {
                sidebar.style.top = null
                sidebar.classList.remove('lg:sticky')
            } else {
                sidebar.style.top = `${offset}px`
                sidebar.classList.add('lg:sticky')
            }
        }

        update()
        on('offset::change', update)
        on('resize', debounce(update, 100), window)
    })
};

on('sticky-sidebars::init', init);
on('load', init, window);
